import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ListTable, ModalView, TableFilters } from '../../../uiComponents';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import {
  actionDictionary,
  moduleDictionary,
  searchFilters,
  searchInputInitialValues,
  systemLogFilters,
} from '../../../../constants/Logs.const';
import { ChangesModalBody } from '../SystemLogModal';
import { getAllSystemLogs } from '../../../../appRedux/actions';
import { Button } from 'antd';

export const SystemHistoryTable = ({ module, columns }) => {
  const {
    privileges: { history: privileges = [] },
    role,
  } = useSelector((state) => state.userAuth);
  const [modalData, setModalData] = useState({});
  const { modal } = useCustomModal();

  const onModalClick = (systemLog) => {
    setModalData(systemLog);
    modal();
  };

  const tableColumns = [{
    title: 'Información',
    sorter: true,
    dataIndex: 'module',
    key: 'module',
    render: (_module, systemLog) =>
      systemLog?.changes ? (
        <Button
          type="link"
          htmlType="button"
          href="#/"
          onClick={() => onModalClick(systemLog)}
        >
          Ver
        </Button>
      ) : (
        <Button type="link" htmlType="button" style={{ color: '#000000' }}>
          Ver
        </Button>
      ),
    path: 'module.name',
  }, {
    title: 'Acción',
    sorter: true,
    dataIndex: 'action',
    key: 'action',
    render: (action) => actionDictionary[action],
  }, ...columns];

  return (
    <>
      <TableFilters
        privileges={privileges}
        role={role}
        searchFilters={searchFilters}
        filters={systemLogFilters}
        searchInputInitialValues={searchInputInitialValues}
      />
      <ModalView title={'Información de los cambios'} width={700}>
        <ChangesModalBody data={modalData} />
      </ModalView>
      <ListTable
        columns={tableColumns}
        getDataFunction={getAllSystemLogs}
        privileges={privileges}
        params={{
          module: module ? module : moduleDictionary.locks,
        }}
      />
    </>
  );
};
